import React from 'react'
import { useNewTranslation } from 'hooks'
import { dateIsInPast, daysToDate } from 'services/dates'
import Text from 'particles/Text'
import { DeadlineTextContainer } from './style'
import { Country } from 'services/api/constants'

interface SubmissionDeadlineTextProps {
    start: string
    end: string
    country: Country
    // optional condition to display null (ex: if campaign hasn't started)
    hidden?: boolean
}

const SubmissionDeadlineText: React.FC<SubmissionDeadlineTextProps> = ({ start, end, country, hidden }) => {
    const [newT] = useNewTranslation()
    const endDaysDiff = daysToDate(end, country)
    const isStarted = dateIsInPast(start, country)

    if (!isStarted || hidden) {
        return null
    }

    // if the end days difference is 0 until 7
    if (endDaysDiff <= 7 && endDaysDiff >= 0) {
        return (
            <DeadlineTextContainer>
                <Text scale="bodyS700" color="tertiary">
                    {newT('warningMessage.campaignDeadlineClose')}
                </Text>
            </DeadlineTextContainer>
        )
    }

    // if end days difference is negative (< 0) or it is past
    if (endDaysDiff < 0) {
        return (
            <DeadlineTextContainer>
                <Text scale="bodyS700" color="error">
                    {newT('errorMessage.businessLogic.campaignDeadlineOver')}
                </Text>
            </DeadlineTextContainer>
        )
    }

    return null
}

export default SubmissionDeadlineText
